import { useNavigate } from "react-router-dom";
import {
    Content,
    EventActions,
    EventCategories,
    EventNames,
    FirebaseEventAction,
    ReceivedGift,
} from "JS/Models";
import { useFirebaseLogger } from "JS/React/Hooks/Firebase";
import { useRouting } from "JS/React/Hooks/Routes";

export const useAudiosHandlers = (searchQuery: string, categoryId: string) => {
    const { linkProvider } = useRouting();
    const { logFirebaseEvent } = useFirebaseLogger();
    const navigate = useNavigate();

    const handleRedirectToDetail = (
        filteredAudio: ReceivedGift | Content,
        isAutoPlay: boolean = false,
        scrollIndex: number = 0,
    ) => {
        if (searchQuery) {
            const action: FirebaseEventAction = {
                action: EventActions.SEARCH,
                category: filteredAudio.isReceived
                    ? EventCategories.GIFT_AUDIOS
                    : EventCategories.AUDIOS,
                nId: filteredAudio.nid,
                skuId: filteredAudio.sku_id,
                contentTitle: filteredAudio.title,
                searchQuery: searchQuery,
            };

            logFirebaseEvent(
                filteredAudio.isReceived
                    ? EventNames.GIFT_AUDIO_SEARCH_OPENED
                    : EventNames.AUDIO_SEARCH_AUDIO_OPENED,
                action,
            );
        }
        navigate(
            linkProvider.react
                .audios()
                .detail(
                    filteredAudio.nid,
                    categoryId,
                    `${isAutoPlay}`,
                    { scrollTo: scrollIndex },
                ),
        );
    };

    return { handleRedirectToDetail };
};
